import React, { useState } from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { unallocatePatient } from "actions/patient-outreaches";
import ActionModal from "./action-modal";

const UnallocateModal = ({ row, onClose }) => {
  const dispatch = useDispatch();
  const [submitting, setSubmitting] = useState(false);
  const [blockedReason, setBlockedReason] = useState(null);

  const handleConfirm = async () => {
    setSubmitting(true);
    setBlockedReason(null);
    try {
      const result = await dispatch(unallocatePatient(row.patientGuid));
      if (result?.blocked) {
        setBlockedReason(result.reason || "Patient is currently on a call.");
      } else if (result?.succeeded) {
        onClose();
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <ActionModal title="Deallocate patient" onClose={onClose}>
      <p>
        Deallocate <strong>{row.patientName || row.patientGuid}</strong> from{" "}
        {row.allocatedCoachName ? (
          <>
            coach <strong>{row.allocatedCoachName}</strong>
          </>
        ) : (
          "their current allocation"
        )}
        ?
      </p>
      <p className="patient-outreach-action-modal__hint">
        The patient will return to the unallocated pool and become available
        for re-allocation. Outreaches currently in flight on a call cannot be
        deallocated.
      </p>

      {blockedReason && (
        <p className="patient-outreach-action-modal__blocked">
          ⚠ Blocked: {blockedReason}
        </p>
      )}

      <div className="patient-outreach-action-modal__footer">
        <button type="button" onClick={onClose} disabled={submitting}>
          Cancel
        </button>
        <button
          type="button"
          className="patient-outreach-action-modal__primary"
          onClick={handleConfirm}
          disabled={submitting}
        >
          {submitting ? "Deallocating…" : "Deallocate"}
        </button>
      </div>
    </ActionModal>
  );
};

UnallocateModal.propTypes = {
  row: PropTypes.shape({
    patientGuid: PropTypes.string.isRequired,
    patientName: PropTypes.string,
    allocatedCoachName: PropTypes.string
  }).isRequired,
  onClose: PropTypes.func.isRequired
};

export default UnallocateModal;
